import { createSlice } from "@reduxjs/toolkit";

const feedbackSlice = createSlice({
  name: "feedback",
  initialState: {
    feedbackData: [],
  },
  reducers: {
    submitFeedback: (state, action) => {
      state.feedbackData = action.payload.feedback;
    },
  },
});

export const { submitFeedback } = feedbackSlice.actions;
export default feedbackSlice.reducer;
